import b from 'b_';
import React from 'react';

import { SimpleCallback } from '../../../typings';
import { Button, ButtonProps } from '../../button/button';
import { TEXT_WEIGHT } from '../../constants';
import { H4 } from '../../header-text/header-text';
import { SimpleText } from '../../simple-text/simple-text';
import Text from '../../text/text';
import { CERTIFICATE_LAYOUT } from '../types';

import './certificate-banner__content.scss';

export type CertificateBannerContentProps<B extends boolean | JSX.Element = true> = {
    headerText: string;
    description?: React.ReactNode;
    layout: CERTIFICATE_LAYOUT;
} & (
    | (false extends B
          ? {
                showButton: B;
                buttonText?: string;
                buttonProps?: ButtonProps;
                onClick?: SimpleCallback;
            }
          : never)
    | (true extends B
          ? {
                showButton?: B | undefined;
                buttonText: string;
                buttonProps?: ButtonProps;
                onClick: SimpleCallback;
            }
          : never)
    | (JSX.Element extends B
          ? {
                showButton: B | null;
                buttonText?: never;
                buttonProps?: never;
                onClick?: never;
            }
          : never)
);

export const CertificateBannerContent = (React.memo as <C>(c: C) => C)(
    <B extends boolean | JSX.Element = true>({
        headerText,
        description,
        buttonText,
        buttonProps,
        layout,
        onClick,
        showButton = true as B,
    }: CertificateBannerContentProps<B>) => {
        return (
            <div className={b('certificate-banner', 'content')}>
                <H4 type={Text.TYPE.MARKDOWN} weight={TEXT_WEIGHT.M}>
                    {headerText}
                </H4>
                {description && (
                    <div className={b('certificate-banner', 'description', { layout })}>
                        <Text size={Text.SIZE.XL} weight={Text.WEIGHT.S}>
                            {description}
                        </Text>
                    </div>
                )}
                {showButton === true ? (
                    <Button
                        className={b('certificate-banner', 'button', { layout })}
                        onClick={onClick}
                        size={Button.SIZE.M}
                        transparencyTheme={Button.TRANSPARENCY_THEME.DARK}
                        view={Button.VIEW.PSEUDO}
                        {...buttonProps}
                    >
                        <SimpleText>{buttonText}</SimpleText>
                    </Button>
                ) : (
                    showButton
                )}
            </div>
        );
    }
);
